<template>
  <div class="message-container" :class="`${level}`">
    <div class="message__body">
      <div v-if="title" name="title" class="message__header">{{title}}</div>
      <div v-if="content" name="content" class="message__content">
        <v-icon v-if="level" class="message__icon">{{levelIcon[level]}}</v-icon>
        <div>{{content}}</div>
      </div>
      <slot></slot>
    </div>

    <v-btn
      class="ml-4"
      v-if="closeBtn"
      @click="close"
      :color="`${level}`"
      small
      icon>
      <v-icon dark>close</v-icon>
    </v-btn>

  </div>
</template>

<script>
export default {
  data() {
    return {
      levelIcon: {
        info: 'info',
        success: 'check_circle',
        warning: 'priority_high',
        error: 'warning'
      }
    };
  },
  props: {
    closeBtn: {
      type: Boolean,
      default: true
    },
    level: {
      type: String,
      default: 'info'
    },
    title: {
      type: String,
      default: null
    },
    content: {
      type: String,
      default: null
    }
  },

  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="stylus" scoped>

.message-container {
  display: flex;
  align-items: center;
  padding: 0.4rem 1rem 0.4rem 1rem;
  overflow: hidden;
  color: white;
  font-size: 1rem;
  border-radius: 4px;
}

.message-container:hover {
}

.message__body {
  margin-right: auto;
  word-break: break-all;
}

.message__header {
  font-size: 1.15rem;
  font-weight: 600;
  padding-right: 1.2rem;
  white-space: nowrap;
  margin-bottom: 0.5rem;
}

.message__content {
  display: flex;
  align-items: center;
}

.message__icon {
  flex-shrink: 1;
  flex-grow: 0;
  padding-left: 0.5rem;
  padding-right: 1rem;
  color: white;
}

.message__body__close {
  margin-left: 1rem;
}
</style>
